import { Square2StackIcon } from '@heroicons/react/24/solid'
import React, { FC, MouseEvent, useState } from 'react'

import { cn } from '@/app/utils'
import { AppToast } from '@/components/shared/toast'

type Props = {
  text: string
  message: string
  className?: string
}

const AppCopyToClipboard: FC<Props> = ({ text, message, className }) => {
  const [isCopied, setIsCopied] = useState(false)

  const handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    navigator.clipboard.writeText(text)
    setIsCopied(true)
  }

  return (
    <>
      <button
        aria-label="Скопировать"
        className={cn('text-grey-100', className)}
        onClick={handleButtonClick}
        data-testid="button-copy-clipboard"
      >
        <Square2StackIcon className="h-20 w-20" />
      </button>

      <AppToast
        opened={isCopied}
        message={message}
        onClose={() => setIsCopied(false)}
        icon={<Square2StackIcon className="h-20 w-20" />}
      />
    </>
  )
}

export default AppCopyToClipboard
